/* Familia Ramírez · Ficha de producto (Rediseño 2026)
   Pasos: aceite → compra única o suscripción → cantidad, y barra de compra fija.
   Los datos vienen de Shopify en <script data-rz-datos> (sections/fr-ficha.liquid).
   Añade al carrito con /cart/add.js (con selling_plan si es suscripción) y abre el carrito lateral. */
(function () {
  'use strict';

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function decodificar(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  /* Formato de dinero de Shopify (mismos marcadores que el filtro money) */
  function dinero(centimos, formato) {
    var valor = Number(centimos) || 0;
    function separar(n, decimales, miles, coma) {
      var partes = (n / 100).toFixed(decimales).split('.');
      return partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles) + (partes[1] ? coma + partes[1] : '');
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      switch (tipo) {
        case 'amount': return separar(valor, 2, ',', '.');
        case 'amount_no_decimals': return separar(valor, 0, ',', '.');
        case 'amount_with_comma_separator': return separar(valor, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return separar(valor, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return separar(valor, 2, "'", '.');
        case 'amount_with_space_separator': return separar(valor, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return separar(valor, 0, ' ', ',');
        default: return separar(valor, 2, '.', ',');
      }
    });
  }

  /* «Pack 6 Botellas Edición Hogar 500 ml» → { etiqueta: '6 botellas', n: 6 } */
  /* «Pack 6 Garrafas 2 L · Virgen extra» → 2 */
  function litrosDesdeTitulo(titulo) {
    var m = String(titulo).match(/(\d+(?:[.,]\d+)?)\s*L\b/);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }
  function cantidadDesdeTitulo(titulo) {
    var m = String(titulo).match(/(\d+)\s*(botellas?|garrafas?|unidades?|latas?|cajas?)\b/i);
    if (m) return { etiqueta: m[1] + ' ' + m[2].toLowerCase(), n: +m[1] };
    return { etiqueta: titulo, n: null };
  }

  function iniciar(root) {
    if (!root || root.__rzFicha) return;
    root.__rzFicha = true;

    var datosEl = root.querySelector('[data-rz-datos]');
    var pasos = root.querySelector('[data-rz-pasos]');
    if (!datosEl || !pasos) return;
    var D;
    try { D = JSON.parse(datosEl.textContent); } catch (e) { return; }
    var T = D.textos || {};
    var formato = decodificar(D.moneyFormat || '{{amount_with_comma_separator}} €');
    function precio(c) { return dinero(c, formato); }

    /* ---------- Opciones a partir de los productos ---------- */
    var opcionAceite = norm(D.opcionAceite || 'Aceite');
    /* Aceite de un producto sin la opción de variante: etiqueta igual a un bloque «Aceite» o, si no, el aceite por defecto */
    function aceiteSinOpcion(p) {
      var etiquetas = (p.tags || []).map(norm);
      var valor = null;
      (D.aceites || []).forEach(function (a) {
        if (!valor && etiquetas.indexOf(norm(a.valor)) > -1) valor = a.valor;
      });
      return valor || D.aceiteDefecto || null;
    }
    var items = [];
    (D.productos || []).forEach(function (p) {
      var oi = -1;
      (p.options || []).forEach(function (nombre, i) { if (norm(nombre) === opcionAceite) oi = i; });
      var aceiteProducto = oi > -1 ? null : aceiteSinOpcion(p);
      (p.variants || []).forEach(function (v) {
        var otros = (v.options || []).filter(function (o, i) { return i !== oi && norm(o) !== 'default title'; });
        var c = otros.length ? { etiqueta: otros.join(' · '), n: null } : cantidadDesdeTitulo(p.title);
        if (otros.length) {
          var num = otros.join(' ').match(/\d+/);
          c.n = num ? +num[0] : null;
        }
        items.push({
          p: p,
          v: v,
          aceite: oi > -1 ? v.options[oi] : aceiteProducto,
          etiqueta: c.etiqueta,
          n: c.n,
          porBotella: /botella/i.test(c.etiqueta),
          /* Garrafas: litros de cada garrafa, del título del producto («Pack 6 Garrafas 2 L») */
          litros: /garrafa/i.test(c.etiqueta) ? litrosDesdeTitulo(p.title) : null
        });
      });
    });
    if (!items.length) return;

    var hayAceite = items.some(function (i) { return i.aceite; });
    var aceites = [];
    if (hayAceite) {
      (D.aceites || []).forEach(function (a) {
        var real = null;
        items.forEach(function (i) { if (!real && i.v.available && i.aceite && norm(i.aceite) === norm(a.valor)) real = i.aceite; });
        if (real) aceites.push({ valor: real, desc: a.desc || '' });
      });
      items.forEach(function (i) {
        if (i.v.available && i.aceite && !aceites.some(function (a) { return norm(a.valor) === norm(i.aceite); })) {
          aceites.push({ valor: i.aceite, desc: '' });
        }
      });
    }
    /* Con un solo aceite en el formato no hay nada que elegir: el paso no sale */
    if (aceites.length < 2) hayAceite = false;

    function deAceite(valor) {
      var lista = items.filter(function (i) {
        if (!hayAceite) return true;
        if (i.aceite) return norm(i.aceite) === norm(valor);
        return aceites.length && norm(valor) === norm(aceites[0].valor);
      });
      return lista
        .map(function (it, k) { return { it: it, k: k }; })
        .sort(function (a, b) {
          var na = a.it.n == null ? Infinity : a.it.n, nb = b.it.n == null ? Infinity : b.it.n;
          return na === nb ? a.k - b.k : na - nb;
        })
        .map(function (x) { return x.it; });
    }
    function primeroDisponible(lista) {
      for (var i = 0; i < lista.length; i++) { if (lista[i].v.available) return lista[i]; }
      return lista[0] || null;
    }
    /* «[frecuencia] · envío gratis» → «Cada 2 meses · envío gratis», con la frecuencia del plan */
    function conPlan(texto, plan) {
      var frecuencia = (plan && plan.frecuencia) || '';
      var t = String(texto || '').replace(/\[frecuencia\]/g, frecuencia).replace(/^\s*·\s*/, '').trim();
      return t.charAt(0).toUpperCase() + t.slice(1);
    }
    function chipDe(plan) {
      if (!plan) return '';
      var a = plan.adj && plan.adj[0];
      if (a && a.type === 'percentage' && Number(a.value) > 0) {
        var v = Number(a.value);
        return '−' + (v % 1 === 0 ? v : String(v).replace('.', ',')) + '\u00a0%';
      }
      return plan.name || '';
    }

    /* ---------- Estado inicial ---------- */
    var S = { aceite: null, modo: 'unica', item: null };
    if (hayAceite) {
      var param = new URLSearchParams(window.location.search).get('aceite');
      if (param) {
        aceites.forEach(function (a) { if (norm(a.valor) === norm(param)) S.aceite = a.valor; });
      }
      if (!S.aceite && aceites.length === 1) S.aceite = aceites[0].valor;
    }
    function elegirPorDefecto() {
      var lista = deAceite(S.aceite);
      var porVariante = null, porProducto = null;
      lista.forEach(function (i) {
        if (!porVariante && i.v.id === D.variantId) porVariante = i;
        if (!porProducto && i.p.id === D.productId && i.v.available) porProducto = i;
      });
      S.item = porVariante || porProducto || primeroDisponible(lista);
    }
    if (!hayAceite || S.aceite) elegirPorDefecto();

    /* ---------- Pintar ---------- */
    function pintar() {
      var html = '', num = 1;

      if (hayAceite) {
        html += '<div class="rz-step rz-step--oil"><h2>' + num + ' · ' + esc(T.pasoAceite) + '</h2><div class="rz-stack">';
        aceites.forEach(function (a) {
          var precios = deAceite(a.valor).map(function (i) { return i.v.price; });
          var min = precios.length ? Math.min.apply(null, precios) : null;
          html += '<button type="button" class="rz-opt" data-rz="aceite" data-valor="' + esc(a.valor) + '" aria-pressed="' + (S.aceite === a.valor) + '">' +
            '<span class="rz-radio" aria-hidden="true"></span>' +
            '<span class="rz-opt__main"><span class="rz-opt__title">' + esc(a.valor) + '</span>' +
            (a.desc ? '<span class="rz-opt__desc">' + esc(a.desc) + '</span>' : '') + '</span>' +
            '<span class="rz-opt__price">' + (min != null ? esc(T.desde) + ' ' + esc(precio(min)) : '') + '</span></button>';
        });
        html += '</div></div>';
        num++;
        if (!S.aceite) {
          html += '<p class="rz-notice">' + esc(T.aviso) + '</p>';
          pasos.innerHTML = html;
          return;
        }
      }

      var lista = deAceite(S.aceite);
      var sel = S.item;
      var plan = sel && sel.v.plans && sel.v.plans[0];
      var hayPlanes = lista.some(function (i) { return i.v.plans && i.v.plans.length; });
      if (sel && sel.p.requiresPlan && plan) S.modo = 'sub';
      var sub = S.modo === 'sub' && !!plan;

      if (hayPlanes) {
        var planChip = plan;
        if (!planChip) lista.forEach(function (i) { if (!planChip && i.v.plans && i.v.plans.length) planChip = i.v.plans[0]; });
        var chip = chipDe(planChip);
        html += '<div class="rz-step"><h2>' + num + ' · ' + esc(T.pasoModo) + '</h2><div class="rz-mode">' +
          '<button type="button" class="rz-opt" data-rz="modo" data-valor="unica" aria-pressed="' + !sub + '"' + (sel && sel.p.requiresPlan ? ' disabled' : '') + '>' +
            '<strong>' + esc(T.unica) + '</strong><span class="rz-sub">' + esc(T.unicaSub) + '</span></button>' +
          '<button type="button" class="rz-opt" data-rz="modo" data-valor="sub" aria-pressed="' + sub + '"' + (plan ? '' : ' disabled') + '>' +
            '<strong>' + esc(T.suscripcion) + (chip ? ' <span class="rz-chip">' + esc(chip) + '</span>' : '') + '</strong>' +
            '<span class="rz-sub">' + esc(conPlan(T.suscripcionSub, planChip)) + '</span></button>' +
          '</div></div>';
        num++;
      }

      html += '<div class="rz-step rz-qty"><h2>' + num + ' · ' + esc(T.pasoCantidad) + '</h2><div class="rz-stack">';
      lista.forEach(function (it, j) {
        var planIt = it.v.plans && it.v.plans[0];
        var val = sub && planIt ? planIt.price : it.v.price;
        var agotado = !it.v.available;
        var detalle = agotado ? esc(T.agotado)
          : it.porBotella && it.n ? esc(precio(Math.round(val / it.n)) + ' ' + T.porUnidad)
          : it.litros && it.n ? esc(precio(Math.round(val / (it.n * it.litros))) + ' ' + T.porLitro)
          : '';
        html += '<button type="button" class="rz-opt" data-rz="cantidad" data-j="' + j + '" aria-pressed="' + (it === sel) + '"' + (agotado ? ' disabled' : '') + '>' +
          '<span class="rz-opt__main"><strong>' + esc(it.etiqueta) + '</strong>' + (detalle ? '<small>' + detalle + '</small>' : '') + '</span>' +
          '<span class="rz-opt__price">' + esc(precio(val)) + '</span></button>';
      });
      html += '</div></div>';

      var base = sel ? sel.v.price : null;
      var total = sel ? (sub ? plan.price : base) : null;
      html += '<div class="rz-buybar"><div>' +
        '<span class="rz-buybar__price">' + (total != null ? esc(precio(total)) : '') + '</span>' +
        (sub && base != null && base > total ? '<s>' + esc(precio(base)) + '</s>' : '') +
        '<small>' + esc(sub ? conPlan(T.barraSuscripcion, plan) : T.barraUnica) + '</small>' +
        '<p class="rz-buybar__msg" data-rz-msg role="status" hidden></p></div>' +
        '<button type="button" class="rz-btn rz-btn--gold" data-rz="anadir"' + (sel && sel.v.available ? '' : ' disabled') + '>' +
        esc(sub ? T.suscribirme : T.anadir) + '</button></div>';

      pasos.innerHTML = html;
    }

    /* ---------- Galería ---------- */
    var galeriaDe = D.productId;
    function pintarGaleria() {
      var sel = S.item;
      if (!sel) return;
      var main = root.querySelector('[data-rz-main]');
      var thumbs = root.querySelector('[data-rz-thumbs]');
      var media = sel.p.media || [];
      /* Sin foto del producto, la de su formato: nunca se queda la foto del producto anterior */
      var propia = sel.v.img || (media[0] && media[0].src);
      var src = propia || sel.p.fotoFormato;
      if (main && src) {
        var img = main.querySelector('img');
        if (!img) {
          main.innerHTML = '';
          img = document.createElement('img');
          img.loading = 'eager';
          main.appendChild(img);
        }
        if (img.getAttribute('src') !== src) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          if (propia && media[0] && media[0].w) { img.width = media[0].w; img.height = media[0].h; }
          else if (!propia) { img.width = 320; img.height = 640; }
          img.src = src;
          img.alt = (propia && media[0] && media[0].alt) || sel.p.title;
          img.toggleAttribute('data-rz-foto-formato', !propia);
        }
      }
      if (thumbs && galeriaDe !== sel.p.id) {
        galeriaDe = sel.p.id;
        thumbs.innerHTML = media.slice(1, 4).map(function (m, k) {
          return '<button type="button" class="rz-gallery__thumb" data-src="' + esc(m.src) + '" data-alt="' + esc(m.alt) + '" aria-label="Ver foto ' + (k + 2) + '">' +
            '<img src="' + esc(m.thumb) + '" alt="" loading="lazy" width="150" height="150"></button>';
        }).join('');
      }
    }
    /* Desplegable «Descripción»: la del pack elegido; si está vacía, no sale */
    function pintarDescripcion() {
      var caja = root.querySelector('[data-rz-desc]');
      var texto = root.querySelector('[data-rz-desc-texto]');
      if (!caja || !texto || !S.item) return;
      var html = S.item.p.description || '';
      if (texto.getAttribute('data-de') !== String(S.item.p.id)) {
        texto.innerHTML = html;
        texto.setAttribute('data-de', String(S.item.p.id));
      }
      caja.hidden = !html.replace(/<[^>]*>/g, '').trim();
    }
    function actualizarUrl() {
      var sel = S.item;
      if (!sel || !window.history || !history.replaceState) return;
      var params = new URLSearchParams();
      if (sel.p.variants.length > 1) params.set('variant', sel.v.id);
      if (S.aceite) params.set('aceite', S.aceite);
      var qs = params.toString();
      try { history.replaceState(history.state, '', sel.p.url + (qs ? '?' + qs : '')); } catch (e) { /* nada */ }
    }

    /* ---------- Añadir al carrito ---------- */
    function anadir(boton) {
      var sel = S.item;
      if (!sel || !sel.v.available) return;
      var plan = sel.v.plans && sel.v.plans[0];
      var linea = { id: sel.v.id, quantity: 1 };
      if (S.modo === 'sub' && plan) linea.selling_plan = plan.id;
      /* El aceite viaja con la línea: se ve en el carrito, en el checkout y en el pedido */
      if (sel.aceite) linea.properties = { Aceite: sel.aceite };
      var msg = root.querySelector('[data-rz-msg]');
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      boton.disabled = true;
      boton.setAttribute('aria-busy', 'true');
      fetch(D.rutas.add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [linea] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || T.error);
          if (window.RZCart) return window.RZCart.refresh().then(function () { window.RZCart.open(boton); });
          window.location.href = D.rutas.cart;
        })
        .catch(function (err) {
          if (msg) { msg.textContent = (err && err.message) || T.error; msg.hidden = false; }
        })
        .then(function () {
          boton.disabled = false;
          boton.removeAttribute('aria-busy');
        });
    }

    /* ---------- Eventos ---------- */
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('.rz-gallery__thumb');
      if (thumb) {
        var img = root.querySelector('[data-rz-main] img');
        if (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = thumb.getAttribute('data-src');
          img.alt = thumb.getAttribute('data-alt') || '';
        }
        root.querySelectorAll('.rz-gallery__thumb').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
        return;
      }
      var b = e.target.closest('[data-rz]');
      if (!b || !pasos.contains(b) || b.disabled) return;
      var accion = b.getAttribute('data-rz');
      if (accion === 'aceite') {
        S.aceite = b.getAttribute('data-valor');
        S.item = primeroDisponible(deAceite(S.aceite));
        pintar(); pintarGaleria(); pintarDescripcion(); actualizarUrl();
        enfocar('[data-rz="aceite"][aria-pressed="true"]');
      } else if (accion === 'modo') {
        S.modo = b.getAttribute('data-valor');
        pintar();
        enfocar('[data-rz="modo"][aria-pressed="true"]');
      } else if (accion === 'cantidad') {
        S.item = deAceite(S.aceite)[+b.getAttribute('data-j')] || S.item;
        pintar(); pintarGaleria(); pintarDescripcion(); actualizarUrl();
        enfocar('[data-rz="cantidad"][aria-pressed="true"]');
      } else if (accion === 'anadir') {
        anadir(b);
      }
    });
    function enfocar(selector) {
      var el = pasos.querySelector(selector);
      if (el) el.focus({ preventScroll: true });
    }

    pintar();
    if (S.item && (S.item.p.id !== D.productId || S.item.v.img)) pintarGaleria();
    pintarDescripcion();
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-rz-ficha]').forEach(iniciar);
  }
  iniciarTodas();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodas);
  document.addEventListener('shopify:section:load', iniciarTodas);
})();
